"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildLink = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _trkHelper = require("@nerdwallet/nw-client-lib/trk-helper");
/** Helper method to construct a url w/ tracking parameters
 *
 * @param                    Object
 *  @key url                 string  base link
 *  @key trkElement          string  TrkElement from @nerdwallet/nw-client-lib/trk-helper
 *  @key trkPageType         string  TrkPageType from @nerdwallet/nw-client-lib/trk-helper
 *  @key trkLocation         string  slug representing the location of the referrer
 *  @key trkSectionCategory  string  slug representing the page section context of the referrer
 *  @key trkTaxonomy         Object  window.nwPageTaxonomy obj
 *
 * @return                string  url w/ tracking data as query params
 */
var buildLink = function buildLink(_ref) {
  var _baseParams;
  var navigationSourceImpressionId = _ref.navigationSourceImpressionId,
    url = _ref.url,
    trkElement = _ref.trkElement,
    trkPageType = _ref.trkPageType,
    trkLocation = _ref.trkLocation,
    trkSectionCategory = _ref.trkSectionCategory,
    trkTaxonomy = _ref.trkTaxonomy;
  var baseParams = (_baseParams = {}, (0, _defineProperty2.default)(_baseParams, _trkHelper.TrkTag.location, trkLocation), (0, _defineProperty2.default)(_baseParams, _trkHelper.TrkTag.element, trkElement), (0, _defineProperty2.default)(_baseParams, _trkHelper.TrkTag.pageType, trkPageType), (0, _defineProperty2.default)(_baseParams, _trkHelper.TrkTag.sectionCategory, trkSectionCategory), _baseParams);
  var params = navigationSourceImpressionId ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, baseParams), {}, {
    navigation_source_impression_id: navigationSourceImpressionId
  }) : baseParams;
  return (0, _trkHelper.setTrk)({
    url: url,
    taxonomy: trkTaxonomy,
    params: params
  });
};
exports.buildLink = buildLink;